import { AxiosError } from "axios";
import { BitacoraResponse } from "../../interfaces/bitacoras/bitacora.interface";
import { middlewareApi } from "../../middlewares/middlewareApi";
import mainApi from "../../api/mainApi";

const reservasService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    getBitacoras: builder.query<
      BitacoraResponse,
      {
        page: number;
        size: number;
        unseen?: string;
      }
    >({
      queryFn: async ({ page, size, unseen }) => {
        try {
          const { data } = await mainApi.get<BitacoraResponse>(
            "bitacoras/getBitacoras",
            {
              params: {
                page,
                size,
                unseen,
              },
            }
          );
          return { data };
        } catch (error) {
          let err = error as AxiosError;
          return {
            error: err.request?.data || err.message,
          };
        }
      },
    }),

    /**
     * Set bitacora mail to read
     */
    readBitacora: builder.mutation<
      any,
      {
        id_bitacora_mail: number;
        id_usuario_confirmacion: number;
      }
    >({
      queryFn: async ({ id_bitacora_mail, id_usuario_confirmacion }) => {
        try {
          const { data } = await mainApi.post<any>("bitacoras/readBitacora", {
            id_bitacora_mail,
            id_usuario_confirmacion,
          });
          return { data };
        } catch (error) {
          let err = error as AxiosError;
          return {
            error: err.request?.data || err.message,
          };
        }
      },
    }),
  }),
});

export const { useGetBitacorasQuery, useReadBitacoraMutation } =
  reservasService;
